import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { RatesApiAdapter } from '../adapters/RatesApiAdapter';

export const useRateDetail = (rateId: number | null) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new RatesApiAdapter(httpClient);

  const {
    data: rate,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['rate', rateId],
    queryFn: () => adapter.getRateById(rateId!),
    enabled: rateId !== null && rateId > 0,
    staleTime: 2 * 60 * 1000,
  });

  return {
    rate,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};
